"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/core/styles");
var _theme = _interopRequireDefault(require("../../theme"));
const useStyles = (0, _styles.makeStyles)({
  root: {
    width: '100%',
    '& .MuiInput-underline:before': {
      border: 'none'
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
      border: 'none'
    },
    '& .MuiInput-underline:after': {
      border: 'none'
    },
    '& .MuiInput-formControl': {
      border: "solid 1px ".concat(_theme.default.palette.grayScale.middleLight),
      borderRadius: 3
    },
    '& label + .MuiInput-formControl': {
      marginTop: '26px'
    },
    '& .MuiInputBase-input': {
      fontSize: _theme.default.typography.pxToRem(16),
      padding: '8px 4px 8px 8px',
      height: '35px',
      color: _theme.default.palette.grayScale.dark,
      fontFamily: _theme.default.typography.proxima.regular,
      textOverflow: 'ellipsis',
      '&::placeholder': {
        color: '#9F9F9F',
        opacity: 1
      }
    },
    '& .MuiInputLabel-formControl': {
      transform: 'none'
    },
    '& .MuiSvgIcon-root': {
      color: '#005EDC'
    },
    '& .MuiInputAdornment-positionStart': {
      marginLeft: '22px',
      marginRight: '4px',
      [_theme.default.breakpoints.down('lg')]: {
        marginLeft: '12px'
      }
    },
    '& .MuiFormLabel-root': {
      fontFamily: _theme.default.typography.proxima.regular,
      color: '#535353',
      fontSize: _theme.default.typography.pxToRem(14),
      lineHeight: _theme.default.typography.pxToRem(17)
    },
    '& .Mui-disabled': {
      color: _theme.default.palette.grayScale.disabled,
      opacity: 1,
      '-webkit-text-fill-color': '#7b7b7b !important',
      '& svg': {
        color: _theme.default.palette.grayScale.disabled
      }
    }
  },
  textFieldError: {
    '& .MuiInput-formControl': {
      border: "solid 1px ".concat(_theme.default.palette.error.main)
    },
    '& .MuiFormHelperText-root': {
      color: _theme.default.palette.error.main,
      fontSize: _theme.default.typography.pxToRem(12),
      letterSpacing: 0,
      lineHeight: _theme.default.typography.pxToRem(18),
      marginBottom: 0,
      marginTop: '10px'
    }
  }
});
var _default = exports.default = useStyles;